import initialState from "./initialState";
import * as types from "../actions/actionTypes";
import { JobsState } from "../types/reduxState";

interface appActions {
  type: string;
  payload: any;
}

export default function jobsReducer(currentState: JobsState, action: appActions): any {
  const state = currentState || initialState.app;
  switch (action.type) {
    case types.SET_SKIPPED_JOBS:
      return {
        ...state,
        skipped: action.payload,
      };

    case types.SET_SHORTLISTED_JOBS:
      return {
        ...state,
        shortlisted: action.payload,
      };

    case types.SET_LISTING_JOBS:
      return {
        ...state,
        listing: action.payload,
      };

    case types.SET_APPLIED_JOBS:
      return {
        ...state,
        applied: action.payload,
      };

    case types.SET_JOB_DETAILS:
      return {
        ...state,
        jobDetails: action.payload,
      };

    case types.SET_JOB_SEARCH_FILTERS:
      return {
        ...state,
        jobSearchFilters: action.payload,
      };

    case types.CLEAR_JOB_SEARCH_FILTERS:
      return {
        ...state,
        jobSearchFilters: action.payload
      };

    default:
      return state;
  }
}
